import React from "react";
import { useOutletContext } from "react-router-dom";
import ATMLoadingButton from "src/components/UI/atoms/ATMLoadingButton/ATMLoadingButton";
import ATMRadioButton from "src/components/UI/atoms/ATMRadioButton/ATMRadioButton";
import ATMCheckbox from "src/components/UI/atoms/formFields/ATMCheckbox/ATMCheckbox";
import ATMDatePicker from "src/components/UI/atoms/formFields/ATMDatePicker/ATMDatePicker";
import ATMMultiSelect from "src/components/UI/atoms/formFields/ATMMultiSelect/ATMMultiSelect";
import ATMTextArea from "src/components/UI/atoms/formFields/ATMTextArea/ATMTextArea";
import useCourse from "src/hooks/useCourse";
import ATMSelectValue from "src/components/UI/atoms/formFields/ATMSelectValue/ATMSelectValue";
import ATMTextField from "src/components/UI/atoms/formFields/ATMTextField/ATMTextField";
import moment from "moment";

const SummaryType = [
  {
    label: "yes",
    value: "YES",
  },
  {
    label: "No",
    value: "NO",
  },
];

const ContactThemOption = [
  {
    label: "On Date",
    value: "ON_DATE",
  },
  {
    label: "On Event",
    value: "ON_EVENT",
  },
];

const Summary = () => {
  const [{ formikProps }]: any = useOutletContext();

  //ALL COURSE
  const { course, isDataLoading: isCourseLoading } = useCourse();
  const CourseOption = course?.map((el: any) => {
    return {
      label: el?.courseName,
      value: el?._id,
      classroomFees: el?.classroomFees,
    };
  });

  const { values, setFieldValue, handleBlur, isSubmitting } = formikProps;

  return (
    <div>
      <div className="grid xl:grid-cols-3 md:grid-cols-2 xs:grid-cols-1 xl:gap-6 gap-4">
        {/* Next FollowUp Required */}
        <div>
          <ATMSelectValue
            name="next_followUp_required"
            value={values.next_followUp_required}
            onChange={(newValue) => {
              setFieldValue("next_followUp_required", newValue)
              setFieldValue("contact_them", '')
              setFieldValue("next_followUp_date", '')
              setFieldValue("next_followup_time", '')
              setFieldValue("new_batch_start", false)
              setFieldValue("followup_batch_start_course", [])
              setFieldValue("next_followup_reason", '');
            }
            }
            onBlur={handleBlur}
            label="Next Followup  Required"
            placeholder="Select Next Followup  Required"
            options={SummaryType}
          />
        </div>

        {values?.next_followUp_required === "YES" && (
          <div>
            <ATMRadioButton
              label="Contact Them"
              name="contact_them"
              value={values?.contact_them || ""}
              className="mt-1 flex"
              options={ContactThemOption}
              onChange={(e) => {
                setFieldValue("contact_them", e);
                setFieldValue("next_followUp_date", '')
                setFieldValue("next_followup_time", '')
                setFieldValue("new_batch_start", false)
                setFieldValue("followup_batch_start_course", [])
              }}
            />
          </div>
        )}
      </div>
      <div className="grid xl:grid-cols-4 md:grid-cols-2 grid-cols-1 mt-3 xl:gap-6 gap-4">
        {values?.contact_them === "ON_DATE" &&
          values?.next_followUp_required === "YES" && (
            <ATMDatePicker
              name="next_followUp_date"
              value={values?.next_followUp_date || null}
              onChange={(newValue) =>
                setFieldValue("next_followUp_date", newValue)
              }
              label="Next Followup  Date "
            />
          )}
        {values?.contact_them === "ON_DATE" &&
          values?.next_followUp_required === "YES" && (
            <ATMTextField
            type="time"
            name="next_followup_time"
            value={moment(values?.next_followup_time, "HH:mm").format("HH:mm")}
            onChange={(e) => {
              let time = moment(e.target.value, "HH:mm");
              setFieldValue("next_followup_time", time);
            }}
            label="Next Followup Time"
            onBlur={handleBlur}
            required
            placeholder="Please Next Followup Time"
          />
          )}
      </div>
      <div>
        {values?.contact_them === "ON_EVENT" &&
          values?.next_followUp_required === "YES" && (
            <div className="flex items-center gap-4 mt-4">
              <ATMCheckbox
                name="new_batch_start"
                extraClasses="font-semibold mt-3"
                checked={values?.new_batch_start}
                onChange={(newValue) => {
                  setFieldValue("new_batch_start", newValue);
                }}
                label="When New Batch Start For"
              />
              {values?.new_batch_start &&
                <div className="w-[300px]">
                  <ATMMultiSelect
                    name="followup_batch_start_course"
                    value={values?.followup_batch_start_course}
                    onChange={(newValue) =>
                      setFieldValue("followup_batch_start_course", newValue)
                    }
                    onBlur={handleBlur}
                    placeholder="Select Course"
                    isLoading={isCourseLoading}
                    options={CourseOption}
                  />
                </div>}
            </div>
          )}
      </div>
      {values?.next_followUp_required === "NO" && (
        <div className="my-5">
          <ATMTextArea
            name="next_followup_reason"
            value={values?.next_followup_reason}
            onChange={(value) => {
              setFieldValue("next_followup_reason", value);
            }}
            label="Reason"
            placeholder="Enter Reason"
            onBlur={handleBlur}
          />
        </div>
      )}

      <div className="flex justify-end mt-2">
        <ATMLoadingButton
          className="flex justify-end w-[90px] px-8"
          isLoading={isSubmitting}
          type="submit"
        >
          Save
        </ATMLoadingButton>
      </div>
    </div>
  );
};

export default Summary;
